const emissionsJcamp = `
##TITLE=
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1
$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=
##JCAMP-DX=5.00
##DATA TYPE=Emissions
##DATA CLASS=XYDATA
##$CSCATEGORY=SPECTRUM
##ORIGIN=
##OWNER=
##XUNITS=wavelength (nm)
##YUNITS=Intensity
##XFACTOR=1.0
##YFACTOR=1.0
##FIRSTX=400.0
##LASTX=800.0
##MAXX=800.0
##MAXY=295.575
##MINX=400.0
##MINY=0.0113152
##NPOINTS=801
##XYDATA= (XY..XY)
400.0, 0.608811
400.5, 0.615689
401.0, 0.616443
401.5, 0.610617
402.0, 0.618529
402.5, 0.625898
403.0, 0.626745
403.5, 0.642452
404.0, 0.653984
404.5, 0.668426
405.0, 0.693905
405.5, 0.707338
406.0, 0.716742
406.5, 0.735379
407.0, 0.761883
407.5, 0.78028
408.0, 0.795166
408.5, 0.833888
409.0, 0.851602
409.5, 0.869763
410.0, 0.892768
410.5, 0.913007
411.0, 0.925021
411.5, 0.947439
412.0, 0.980634
412.5, 1.01112
413.0, 1.03989
413.5, 1.07309
414.0, 1.094
414.5, 1.12549
415.0, 1.16512
415.5, 1.18371
416.0, 1.21937
416.5, 1.25908
417.0, 1.29034
417.5, 1.32841
418.0, 1.37674
418.5, 1.41125
419.0, 1.45465
419.5, 1.50865
420.0, 1.5557
420.5, 1.61629
421.0, 1.67313
421.5, 1.73669
422.0, 1.80905
422.5, 1.87874
423.0, 1.95808
423.5, 2.05486
424.0, 2.13533
424.5, 2.22506
425.0, 2.34541
425.5, 2.47615
426.0, 2.58232
426.5, 2.70404
427.0, 2.84621
427.5, 3.00495
428.0, 3.173
428.5, 3.3476
429.0, 3.50437
429.5, 3.66549
430.0, 3.81981
430.5, 3.96744
431.0, 4.13788
431.5, 4.30222
432.0, 4.45995
432.5, 4.61545
433.0, 4.78758
433.5, 4.95117
434.0, 5.13505
434.5, 5.31459
435.0, 5.5284
435.5, 5.7419
436.0, 5.95627
436.5, 6.18417
437.0, 6.42113
437.5, 6.68898
438.0, 6.95963
438.5, 7.24111
439.0, 7.5132
439.5, 7.80232
440.0, 8.09318
440.5, 8.43796
441.0, 8.78392
441.5, 9.14622
442.0, 9.56067
442.5, 9.9602
443.0, 10.363
443.5, 10.827
444.0, 11.2844
444.5, 11.8045
445.0, 12.3301
445.5, 12.8993
446.0, 13.5231
446.5, 14.1872
447.0, 14.8002
447.5, 15.4975
448.0, 16.3028
448.5, 17.084
449.0, 17.953
449.5, 18.8203
450.0, 19.7138
450.5, 20.6804
451.0, 21.7073
451.5, 22.7869
452.0, 23.9273
452.5, 25.0345
453.0, 26.2184
453.5, 27.449
454.0, 28.6943
454.5, 30.0957
455.0, 31.5345
455.5, 33.0185
456.0, 34.4681
456.5, 36.0413
457.0, 37.716
457.5, 39.3449
458.0, 41.0602
458.5, 42.8188
459.0, 44.6892
459.5, 46.6003
460.0, 48.5714
460.5, 50.51
461.0, 52.5727
461.5, 54.6372
462.0, 56.6855
462.5, 58.8889
463.0, 61.1084
463.5, 63.4482
464.0, 65.7319
464.5, 68.1632
465.0, 70.6652
465.5, 73.1247
466.0, 75.6388
466.5, 78.2951
467.0, 80.9005
467.5, 83.5833
468.0, 86.3856
468.5, 89.0998
469.0, 91.9968
469.5, 94.9725
470.0, 98.0824
470.5, 101.146
471.0, 104.189
471.5, 107.334
472.0, 110.333
472.5, 113.407
473.0, 116.585
473.5, 119.777
474.0, 122.952
474.5, 126.156
475.0, 129.431
475.5, 132.826
476.0, 136.213
476.5, 139.469
477.0, 142.787
477.5, 146.205
478.0, 149.66
478.5, 152.97
479.0, 156.45
479.5, 159.946
480.0, 163.231
480.5, 166.505
481.0, 169.781
481.5, 173.093
482.0, 176.446
482.5, 179.725
483.0, 183.034
483.5, 186.249
484.0, 189.212
484.5, 190.807
485.0, 190.766
485.5, 191.218
486.0, 191.962
486.5, 192.714
487.0, 193.899
487.5, 195.714
488.0, 197.564
488.5, 199.128
489.0, 200.584
489.5, 201.921
490.0, 203.147
490.5, 204.213
491.0, 205.15
491.5, 205.912
492.0, 206.611
492.5, 206.933
493.0, 207.281
493.5, 207.572
494.0, 207.706
494.5, 207.635
495.0, 207.506
495.5, 207.513
496.0, 207.294
496.5, 206.965
497.0, 206.744
497.5, 206.535
498.0, 206.352
498.5, 205.996
499.0, 205.586
499.5, 205.079
500.0, 204.625
500.5, 204.206
501.0, 203.846
501.5, 205.345
502.0, 207.81
502.5, 210.014
503.0, 211.604
503.5, 213.203
504.0, 214.134
504.5, 214.62
505.0, 214.926
505.5, 215.474
506.0, 216.35
506.5, 217.173
507.0, 217.975
507.5, 219.053
508.0, 220.053
508.5, 221.181
509.0, 222.405
509.5, 223.709
510.0, 224.972
510.5, 226.508
511.0, 228.089
511.5, 229.737
512.0, 231.342
512.5, 232.989
513.0, 234.656
513.5, 236.669
514.0, 238.449
514.5, 240.168
515.0, 241.93
515.5, 243.698
516.0, 245.56
516.5, 247.429
517.0, 249.443
517.5, 251.388
518.0, 253.452
518.5, 255.299
519.0, 257.23
519.5, 259.101
520.0, 261.048
520.5, 263.086
521.0, 265.007
521.5, 267.117
522.0, 269.116
522.5, 271.008
523.0, 272.7
523.5, 274.499
524.0, 276.166
524.5, 277.797
525.0, 279.45
525.5, 281.1
526.0, 282.568
526.5, 284.123
527.0, 285.572
527.5, 286.887
528.0, 288.078
528.5, 289.352
529.0, 290.432
529.5, 291.415
530.0, 292.087
530.5, 292.849
531.0, 293.703
531.5, 294.139
532.0, 294.531
532.5, 294.985
533.0, 295.296
533.5, 295.537
534.0, 295.575
534.5, 295.57
535.0, 295.5
535.5, 295.252
536.0, 294.935
536.5, 294.551
537.0, 293.896
537.5, 293.256
538.0, 292.309
538.5, 291.397
539.0, 290.386
539.5, 289.547
540.0, 288.373
540.5, 287.26
541.0, 286.087
541.5, 284.851
542.0, 283.466
542.5, 282.165
543.0, 280.724
543.5, 279.167
544.0, 277.687
544.5, 276.119
545.0, 274.503
545.5, 272.851
546.0, 271.032
546.5, 269.399
547.0, 267.536
547.5, 265.531
548.0, 263.727
548.5, 261.848
549.0, 259.883
549.5, 257.696
550.0, 255.485
550.5, 253.503
551.0, 251.506
551.5, 249.525
552.0, 247.387
552.5, 245.09
553.0, 243.01
553.5, 240.879
554.0, 238.735
554.5, 236.695
555.0, 234.704
555.5, 232.636
556.0, 230.489
556.5, 228.347
557.0, 226.207
557.5, 224.177
558.0, 222.101
558.5, 219.931
559.0, 217.872
559.5, 215.718
560.0, 213.554
560.5, 211.403
561.0, 209.248
561.5, 207.077
562.0, 204.982
562.5, 202.852
563.0, 200.77
563.5, 198.777
564.0, 196.746
564.5, 194.67
565.0, 192.691
565.5, 190.751
566.0, 188.908
566.5, 186.94
567.0, 184.853
567.5, 182.776
568.0, 180.716
568.5, 178.918
569.0, 177.251
569.5, 175.329
570.0, 173.342
570.5, 171.401
571.0, 169.535
571.5, 167.63
572.0, 165.719
572.5, 163.945
573.0, 162.172
573.5, 160.376
574.0, 158.449
574.5, 156.692
575.0, 154.897
575.5, 153.122
576.0, 151.287
576.5, 149.526
577.0, 147.724
577.5, 145.889
578.0, 144.31
578.5, 142.567
579.0, 140.944
579.5, 139.25
580.0, 137.608
580.5, 135.877
581.0, 134.333
581.5, 132.762
582.0, 131.22
582.5, 129.554
583.0, 128.138
583.5, 126.605
584.0, 125.07
584.5, 123.518
585.0, 121.914
585.5, 120.288
586.0, 118.874
586.5, 117.482
587.0, 116.125
587.5, 114.679
588.0, 113.321
588.5, 111.878
589.0, 110.419
589.5, 108.999
590.0, 107.657
590.5, 106.29
591.0, 104.818
591.5, 103.592
592.0, 102.239
592.5, 100.961
593.0, 99.7167
593.5, 98.5337
594.0, 97.2873
594.5, 96.0779
595.0, 94.8367
595.5, 93.5503
596.0, 92.3
596.5, 91.1509
597.0, 89.9422
597.5, 88.7856
598.0, 87.5134
598.5, 86.4447
599.0, 85.2375
599.5, 84.0793
600.0, 82.9011
600.5, 81.7548
601.0, 80.6481
601.5, 79.4993
602.0, 78.3594
602.5, 77.2713
603.0, 76.2124
603.5, 75.1017
604.0, 73.9997
604.5, 72.9597
605.0, 71.902
605.5, 70.8394
606.0, 69.8184
606.5, 68.787
607.0, 67.8539
607.5, 66.9028
608.0, 65.9867
608.5, 65.0581
609.0, 64.0834
609.5, 63.1704
610.0, 62.3142
610.5, 61.3825
611.0, 60.4402
611.5, 59.6692
612.0, 58.7675
612.5, 57.8997
613.0, 57.02
613.5, 56.1698
614.0, 55.3155
614.5, 54.4509
615.0, 53.6505
615.5, 52.8241
616.0, 52.0874
616.5, 51.2773
617.0, 50.427
617.5, 49.6606
618.0, 49.012
618.5, 48.1907
619.0, 47.407
619.5, 46.601
620.0, 45.8876
620.5, 45.1871
621.0, 44.5477
621.5, 43.8614
622.0, 43.1696
622.5, 42.5009
623.0, 41.8504
623.5, 41.1278
624.0, 40.4399
624.5, 39.7997
625.0, 39.1858
625.5, 38.5162
626.0, 37.8238
626.5, 37.1994
627.0, 36.5964
627.5, 35.9932
628.0, 35.4215
628.5, 34.863
629.0, 34.2745
629.5, 33.7432
630.0, 33.1727
630.5, 32.6003
631.0, 32.0512
631.5, 31.4812
632.0, 30.9768
632.5, 30.5118
633.0, 30.023
633.5, 29.4835
634.0, 28.9898
634.5, 28.5421
635.0, 28.1114
635.5, 27.6556
636.0, 27.2017
636.5, 26.6916
637.0, 26.2219
637.5, 25.8044
638.0, 25.304
638.5, 24.8383
639.0, 24.3964
639.5, 24.0261
640.0, 23.6212
640.5, 23.1984
641.0, 22.814
641.5, 22.4763
642.0, 22.1368
642.5, 21.7521
643.0, 21.3784
643.5, 20.9953
644.0, 20.5762
644.5, 20.2087
645.0, 19.8722
645.5, 19.5594
646.0, 19.2796
646.5, 18.9546
647.0, 18.6239
647.5, 18.3312
648.0, 18.0073
648.5, 17.6935
649.0, 17.3712
649.5, 17.1005
650.0, 16.7761
650.5, 16.4968
651.0, 16.1812
651.5, 15.8822
652.0, 15.6015
652.5, 15.3223
653.0, 15.0368
653.5, 14.8148
654.0, 14.5627
654.5, 14.309
655.0, 14.0064
655.5, 13.7653
656.0, 13.5404
656.5, 13.2644
657.0, 13.0371
657.5, 12.7771
658.0, 12.5469
658.5, 12.3073
659.0, 12.111
659.5, 11.9489
660.0, 11.7545
660.5, 11.5293
661.0, 11.3301
661.5, 11.1166
662.0, 10.9139
662.5, 10.7418
663.0, 10.5127
663.5, 10.289
664.0, 10.0973
664.5, 9.91813
665.0, 9.72299
665.5, 9.53983
666.0, 9.37753
666.5, 9.2483
667.0, 9.0703
667.5, 8.91668
668.0, 8.76836
668.5, 8.58915
669.0, 8.4231
669.5, 8.26602
670.0, 8.13683
670.5, 7.96352
671.0, 7.78261
671.5, 7.60609
672.0, 7.45503
672.5, 7.28707
673.0, 7.18464
673.5, 7.03958
674.0, 6.90637
674.5, 6.76469
675.0, 6.64211
675.5, 6.50743
676.0, 6.37745
676.5, 6.22989
677.0, 6.10518
677.5, 5.98658
678.0, 5.84651
678.5, 5.74244
679.0, 5.64814
679.5, 5.53987
680.0, 5.40428
680.5, 5.29968
681.0, 5.2004
681.5, 5.07656
682.0, 4.9694
682.5, 4.87591
683.0, 4.78495
683.5, 4.68543
684.0, 4.59701
684.5, 4.52026
685.0, 4.40901
685.5, 4.331
686.0, 4.26051
686.5, 4.19992
687.0, 4.13772
687.5, 4.05255
688.0, 3.96286
688.5, 3.90782
689.0, 3.84851
689.5, 3.7787
690.0, 3.68694
690.5, 3.60856
691.0, 3.53309
691.5, 3.46934
692.0, 3.3951
692.5, 3.34453
693.0, 3.27006
693.5, 3.21443
694.0, 3.13821
694.5, 3.06757
695.0, 3.02349
695.5, 2.96047
696.0, 2.90533
696.5, 2.86252
697.0, 2.81215
697.5, 2.76779
698.0, 2.69254
698.5, 2.63357
699.0, 2.55941
699.5, 2.52495
700.0, 2.48402
700.5, 2.42841
701.0, 2.3821
701.5, 2.3093
702.0, 2.25774
702.5, 2.23801
703.0, 2.19235
703.5, 2.13119
704.0, 2.06673
704.5, 2.02544
705.0, 1.99173
705.5, 1.95809
706.0, 1.9147
706.5, 1.86804
707.0, 1.83463
707.5, 1.78428
708.0, 1.75539
708.5, 1.71922
709.0, 1.68655
709.5, 1.64694
710.0, 1.62756
710.5, 1.58312
711.0, 1.55262
711.5, 1.51065
712.0, 1.46873
712.5, 1.42303
713.0, 1.39969
713.5, 1.38525
714.0, 1.3493
714.5, 1.31745
715.0, 1.29555
715.5, 1.26618
716.0, 1.24521
716.5, 1.22179
717.0, 1.19218
717.5, 1.15523
718.0, 1.12973
718.5, 1.10558
719.0, 1.08592
719.5, 1.05198
720.0, 1.03041
720.5, 1.00137
721.0, 0.977831
721.5, 0.948761
722.0, 0.930911
722.5, 0.906464
723.0, 0.882443
723.5, 0.863338
724.0, 0.838748
724.5, 0.813431
725.0, 0.800856
725.5, 0.785739
726.0, 0.773734
726.5, 0.771352
727.0, 0.765632
727.5, 0.754063
728.0, 0.739182
728.5, 0.737067
729.0, 0.714806
729.5, 0.688048
730.0, 0.673943
730.5, 0.661829
731.0, 0.639847
731.5, 0.627071
732.0, 0.607165
732.5, 0.590783
733.0, 0.571272
733.5, 0.557248
734.0, 0.551462
734.5, 0.536873
735.0, 0.528909
735.5, 0.533759
736.0, 0.525631
736.5, 0.508665
737.0, 0.504895
737.5, 0.490307
738.0, 0.479657
738.5, 0.472847
739.0, 0.463091
739.5, 0.448371
740.0, 0.439887
740.5, 0.434803
741.0, 0.419084
741.5, 0.397374
742.0, 0.377531
742.5, 0.363784
743.0, 0.35031
743.5, 0.34517
744.0, 0.339509
744.5, 0.339587
745.0, 0.328797
745.5, 0.32535
746.0, 0.316521
746.5, 0.32123
747.0, 0.321918
747.5, 0.323073
748.0, 0.314619
748.5, 0.304859
749.0, 0.293168
749.5, 0.285459
750.0, 0.269866
750.5, 0.261831
751.0, 0.256948
751.5, 0.240482
752.0, 0.238543
752.5, 0.239589
753.0, 0.233852
753.5, 0.237834
754.0, 0.230985
754.5, 0.227506
755.0, 0.218996
755.5, 0.21883
756.0, 0.220063
756.5, 0.216851
757.0, 0.208293
757.5, 0.203984
758.0, 0.204004
758.5, 0.193933
759.0, 0.189798
759.5, 0.18988
760.0, 0.187443
760.5, 0.178026
761.0, 0.175454
761.5, 0.165942
762.0, 0.164835
762.5, 0.161194
763.0, 0.159984
763.5, 0.164244
764.0, 0.159939
764.5, 0.161173
765.0, 0.159522
765.5, 0.156448
766.0, 0.152956
766.5, 0.149222
767.0, 0.145124
767.5, 0.135762
768.0, 0.127582
768.5, 0.116956
769.0, 0.115916
769.5, 0.114726
770.0, 0.112243
770.5, 0.105363
771.0, 0.108749
771.5, 0.106172
772.0, 0.101994
772.5, 0.103756
773.0, 0.0963631
773.5, 0.0896667
774.0, 0.0863852
774.5, 0.0822998
775.0, 0.0751632
775.5, 0.0752349
776.0, 0.0722959
776.5, 0.0684348
777.0, 0.0696659
777.5, 0.0627365
778.0, 0.0640981
778.5, 0.065616
779.0, 0.0629221
779.5, 0.0571957
780.0, 0.052281
780.5, 0.0509311
781.0, 0.0495644
781.5, 0.0463786
782.0, 0.046733
782.5, 0.0423936
783.0, 0.0386875
783.5, 0.0349155
784.0, 0.0259163
784.5, 0.028397
785.0, 0.0227816
785.5, 0.0214889
786.0, 0.0202082
786.5, 0.0185266
787.0, 0.0179278
787.5, 0.0202475
788.0, 0.0196759
788.5, 0.0219514
789.0, 0.0309213
789.5, 0.0264383
790.0, 0.0236135
790.5, 0.0180345
791.0, 0.0169638
791.5, 0.0129427
792.0, 0.0150573
792.5, 0.0121492
793.0, 0.0132592
793.5, 0.0138522
794.0, 0.012745
794.5, 0.0113152
795.0, 0.018881
795.5, 0.0217344
796.0, 0.0201774
796.5, 0.0266482
797.0, 0.0255316
797.5, 0.0243361
798.0, 0.0275861
798.5, 0.0255186
799.0, 0.0267742
799.5, 0.0243003
800.0, 0.0258263
$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##$OBSERVEDINTEGRALS= (X Y Z)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
$$ === CHEMSPECTRA SIMULATION ===
##$CSSIMULATIONPEAKS=
##END=


$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=
##JCAMP-DX=5.00
##DATA TYPE=EmissionsPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.05
##MAXX=800.0
##MAXY=295.575
##MINX=400.0
##MINY=0.0113152
##$CSSOLVENTNAME=
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=0
##PEAKTABLE= (XY..XY)
##END=


$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=
##JCAMP-DX=5.00
##DATA TYPE=EmissionsPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.05
##MAXX=800.0
##MAXY=295.575
##MINX=400.0
##MINY=0.0113152
##NPOINTS=4
##PEAKTABLE= (XY..XY)
534.0, 295.575
494.0, 207.706
495.5, 207.513
484.5, 190.807
##END=

##END=

`;
export default emissionsJcamp;
